import styles from "../css/skills1.module.css";

export const Skills1 = () => {
  return (
    <>
      <div id="skills" className={styles.container1}>
        <h1 className={styles.heading}>MY Skills</h1>
        <p>Soft Skills</p>
        <div className={styles.toolContainer1}>
       
          <div>
            {/* 1 */}
              <img width="200vw"
                src="https://chandrashekharjoshi302.github.io/static/media/collabrative.697daf5b0a056e39d2ea.png"
                alt=""
              />
            <h1>Collaborative</h1>
          </div>
          <div>
            {/* 2 */}
           
              <img width="200vw"
                src="https://chandrashekharjoshi302.github.io/static/media/creativity1.445675a0a00c2757a1d6.png"
                alt=""
              />
           
            <h1>Creative Thinking</h1>
          </div>
          <div>
            {/* 3 */}
           
              <img width="200px"
                src="https://chandrashekharjoshi302.github.io/static/media/problemSolv.ddf49384f01d0b6de6c0.png"
                alt=""
              />
          
            <h1>Problem Solving</h1>
          </div>
          <div>
            {/* 4 */}
           
              <img 
                src="https://chandrashekharjoshi302.github.io/static/media/timeManage.4644a4b2b8ed5f538eec.png"
                alt=""
              />
           
            <h1>Time Management</h1>
          </div>
        </div>
        <div id="skills" className={styles.container2}>
            <p>Teck Skills</p>
        <div className={styles.toolContainer1}>
       
          <div>
            {/* 1 */}
              <img
                src="https://chandrashekharjoshi302.github.io/static/media/frontend-icon-22.23cac2a4e78e5e715d52.jpg"
                alt=""
              />
            <h1>Frontend</h1>
          </div>
          <div>
            {/* 2 */}
           
              <img
                src="https://chandrashekharjoshi302.github.io/static/media/backend.cd86763da06f05c86ca6.png"
                alt=""
              />
           
            <h1>Backend</h1>
          </div>
          <div>
            {/* 3 */}
           
              <img
                src="https://chandrashekharjoshi302.github.io/static/media/dsa.77509298a343d123a7bd.png"
                alt=""
              />
          
            <h1>DSA</h1>
          </div>
          <div>
            {/* 4 */}
           
              <img
                src="https://chandrashekharjoshi302.github.io/static/media/projectManagement.56532bbb9da241b0f1c8.png"
                alt=""
              />
           
            <h1>Project Management</h1>
          </div>
        </div></div>
      </div>
    </>
  );
};
